{
  "en": "Inglés",
  "de": "Alemán",
  "fr": "Francés",
  "es": "Español",
  "cs": "Checo",
  "da": "Danés",
  "et": "Estonio",
  "fi": "Finés",
  "hr": "Croata",
  "hu": "Húngaro",
  "it": "Italiano",
  "lt": "Lituano",
  "lv": "Letón",
  "nl": "Neerlandés",
  "nb": "Bokmal noruego",
  "pl": "Polaco",
  "pt": "Portugués",
  "ro": "Rumano",
  "sk": "Eslovaco",
  "sl": "Esloveno",
  "sq": "Albanés",
  "sv": "Sueco"
}
